import { useState } from 'react';
import { Badge, Button, Offcanvas } from 'react-bootstrap';

// Enough English for our result nouns: piece/pieces, vehicle/vehicles, stay/stays,
// property/properties, result/results.
const pluralize = (noun) => (/[^aeiou]y$/i.test(noun) ? `${noun.slice(0, -1)}ies` : `${noun}s`);

// Right-hand slide-in filter panel for narrow screens (react-bootstrap Offcanvas), opened from a
// floating button. On >= lg the page shows its filters inline and this stays hidden (CSS
// `d-lg-none`); this is the < lg "Filters" affordance. Shared, identical, across every vertical's
// ItemList - the page passes its own filter controls as children.
//
//  - activeCount   number of filters currently applied (shown as a badge on the button; also
//                  gates the "Clear all" button)
//  - resultCount   how many listings the current filters return - shown on the confirm button
//                  ("Show 12 rings"); pass undefined while loading to show a plain "Show results"
//  - resultNoun    singular noun for resultCount ("ring" -> "Show 1 ring" / "Show 4 rings")
//  - onClearAll    optional; when given, a "Clear all" button appears (disabled at activeCount 0)
export default function MobileFilterPanel({
  activeCount = 0,
  resultCount,
  resultNoun = 'result',
  onClearAll,
  children
}) {
  const [open, setOpen] = useState(false);

  const showLabel = resultCount == null
    ? 'Show results'
    : `Show ${resultCount} ${resultCount === 1 ? resultNoun : pluralize(resultNoun)}`;

  return (
    <>
      <Button
        variant="dark"
        className="d-lg-none mobile-filter-fab"
        onClick={() => setOpen(true)}
        aria-label="Open filters and sort"
      >
        <span aria-hidden="true">⚙</span> Filters
        {activeCount > 0 && <Badge bg="light" text="dark" className="ms-2">{activeCount}</Badge>}
      </Button>

      <Offcanvas
        show={open}
        onHide={() => setOpen(false)}
        placement="end"
        className="d-lg-none mobile-filter-panel"
        aria-labelledby="mobile-filter-panel-title"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title id="mobile-filter-panel-title">Filters &amp; sort</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="d-flex flex-column">
          {children}
          <div className="mt-auto d-flex gap-2 pt-3 border-top">
            {onClearAll && (
              <Button
                variant="outline-secondary"
                className="flex-fill"
                onClick={onClearAll}
                disabled={activeCount === 0}
              >
                Clear all
              </Button>
            )}
            <Button variant="primary" className="flex-fill" onClick={() => setOpen(false)}>
              {showLabel}
            </Button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
